import { Routes } from '@angular/router';

import { authGuard } from './auth/auth.guard';

import { HomePageComponent } from './pages/home-page/home-page.component';
import { ConversationPageComponent } from './pages/conversation-page/conversation-page.component';
import { CreatorProfilePageComponent } from './pages/creator-profile-page/creator-profile-page.component';
import { ImageGenerationPageComponent } from './pages/image-generation-page/image-generation-page.component';

export const routes: Routes = [
  { path: '', component: HomePageComponent },
  { path: 'lander', component: HomePageComponent },
  // { path: 'chats', component: ConversationsPageComponent, canActivate: [authGuard] },
  { path: 'chat/:creatorId', component: ConversationPageComponent, canActivate: [authGuard] },
  { path: 'chat', component: ConversationPageComponent, canActivate: [authGuard] },
  { path: 'generate', component: ImageGenerationPageComponent, canActivate: [authGuard] },
  { path: 'creator/:creatorId', component: CreatorProfilePageComponent },
  { path: '**', redirectTo: '', pathMatch: 'full' }
];
